export default {
  openSidebar: false,
}
